import React from 'react'
import MovimentoEstoqueListPageContainer from './movimento-estoque-list-page-container'

export class MovimentoEstoqueListPage extends React.Component {
  render() {
    return <MovimentoEstoqueListPageContainer {...this.props} />
  }
}
